/* złoteserce: Korona Cierniowa, zestawy 1/2/3 szt. z wyborem koloru dla każdej sztuki */
(() => {
  const zl = (v) => {
    const r = Math.round(v * 100) / 100;
    return (Number.isInteger(r) ? String(r) : r.toFixed(2).replace('.', ',')) + ' zł';
  };
  const root0 = () => window.Shopify?.routes?.root || '/';

  function init(root) {
    if (root.dataset.zkReady) return;
    root.dataset.zkReady = '1';
    let cfg;
    try { cfg = JSON.parse(root.querySelector('[data-zk-cfg]').textContent); } catch (e) { return; }
    const tiles = root.querySelectorAll('[data-zk-qty]');
    const slots = root.querySelector('[data-zk-slots]');
    const btn = root.querySelector('[data-zk-atc]');
    const label = root.querySelector('[data-zk-label]');
    const err = root.querySelector('[data-zk-err]');
    const sticky = root.querySelector('[data-zk-sticky]');
    const stickyPrice = root.querySelector('[data-zk-sticky-price]');
    const stickyBtn = root.querySelector('[data-zk-sticky-btn]');
    const anyAvailable = cfg.colors.some(c => c.available);
    const firstAvail = (cfg.colors.find(c => c.key === cfg.current && c.available) || cfg.colors.find(c => c.available) || cfg.colors[0]).key;

    let qty = 2;
    const sel = [firstAvail, firstAvail, firstAvail];

    const renderSlots = () => {
      slots.innerHTML = '';
      if (cfg.colors.length < 2 && qty === 1) return;
      for (let i = 0; i < qty; i++) {
        const row = document.createElement('div');
        row.className = 'zk-slot';
        const name = qty > 1 ? `Naszyjnik ${i + 1}` : 'Kolor';
        row.innerHTML = `<span class="zk-slot__n">${name}</span><div class="dr-pigulki" role="group" aria-label="${name}: kolor">` +
          cfg.colors.map(c => `<button type="button" class="dr-pigulka" data-i="${i}" data-c="${c.key}" aria-pressed="${sel[i] === c.key}"${c.available ? '' : ' disabled'}><span class="dr-kropka dr-kropka--${c.dot}"></span>${c.label}</button>`).join('') +
          '</div>';
        slots.appendChild(row);
      }
    };

    const paint = () => {
      tiles.forEach(t => t.setAttribute('aria-checked', String(+t.dataset.zkQty === qty)));
      const price = cfg.prices[String(qty)];
      if (anyAvailable) label.textContent = `Dodaj do koszyka · ${zl(price)}`;
      if (stickyPrice) stickyPrice.textContent = qty > 1 ? `${zl(price)} za ${qty} szt.` : zl(price);
      renderSlots();
    };

    tiles.forEach(t => t.addEventListener('click', () => { qty = +t.dataset.zkQty; paint(); }));
    slots.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-c]');
      if (!b || b.disabled) return;
      sel[+b.dataset.i] = b.dataset.c;
      renderSlots();
    });

    btn.addEventListener('click', async () => {
      err.textContent = '';
      btn.disabled = true;
      const prev = label.textContent;
      label.textContent = 'Dodaję…';
      try {
        const counts = {};
        for (let i = 0; i < qty; i++) {
          const c = cfg.colors.find(x => x.key === sel[i]) || cfg.colors[0];
          counts[c.id] = (counts[c.id] || 0) + 1;
        }
        const items = Object.entries(counts).map(([id, q]) => ({ id: +id, quantity: q }));
        const ids = typeof window.drSectionIds === 'function' ? window.drSectionIds() : [];
        const body = { items };
        if (ids.length) body.sections = ids.join(',');
        const res = await fetch(root0() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'Nie udało się dodać do koszyka.');
        label.textContent = 'Dodano ✓';
        document.dispatchEvent(new CustomEvent('dr:added', { detail: data }));
        if (typeof window.drAfterAdd === 'function') window.drAfterAdd(data);
        else window.location.href = root0() + 'cart';
      } catch (e) {
        err.textContent = e.message;
        label.textContent = prev;
      } finally {
        setTimeout(() => {
          btn.disabled = !anyAvailable;
          if (label.textContent === 'Dodano ✓') paint();
        }, 1600);
      }
    });

    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const on = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        stickyBtn.tabIndex = on ? 0 : -1;
      }).observe(btn);
      stickyBtn.addEventListener('click', () => {
        root.querySelector('.zk-zestawy').scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    document.querySelectorAll('[data-zk-go]').forEach(a => a.addEventListener('click', (e) => {
      e.preventDefault();
      const q = +a.dataset.zkGo;
      if (q) { qty = q; paint(); }
      root.querySelector('.zk-zestawy').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }));

    paint();
  }

  const boot = () => document.querySelectorAll('[data-zk]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
